import {
    ColDef,
    ColGroupDef,
    GridOptions,
    GridReadyEvent,
    SizeColumnsToFitGridStrategy,
} from 'ag-grid-community'
import { AgGridReact } from 'ag-grid-react'
import { Box, Container, Header, Select, SpaceBetween } from '@amzn/awsui-components-react'
import { STANDARD_PAGE_SIZE } from './Constants'

interface ObjectSelectMetadata {
    handler: any
    selected: any
    options: any[]
    loading: boolean
}

interface AgGridTableProps {
    setGridApi: any
    colDefs: ColDef[] | ColGroupDef[]
    rowSelectionType?: 'single' | 'multiple'
    onSelectionChanged: any
    autoSizeStrategy?: SizeColumnsToFitGridStrategy
    noRowsOverlayComponent?: () => JSX.Element
    includeTableHeader: boolean
    tableHeaderName?: string
    primaryButton?: any
    primaryButtonPermission?: boolean
    actionDropdown?: any
    actionDropdownPermission?: boolean
    exportButton?: any
    additionalActions?: any
    selectors?: ObjectSelectMetadata[]
    additionalSelectors?: any
}

const GenericAGGridTable = (props: AgGridTableProps) => {
    const {
        setGridApi,
        colDefs,
        rowSelectionType = 'single',
        onSelectionChanged,
        autoSizeStrategy = { type: 'fitCellContents' },
        noRowsOverlayComponent = undefined,
        includeTableHeader,
        tableHeaderName = '',
        primaryButton = <></>,
        primaryButtonPermission = primaryButton === <></>,
        actionDropdown = <></>,
        actionDropdownPermission = actionDropdown === <></>,
        exportButton = <></>,
        additionalActions = <></>,
        selectors = [],
        additionalSelectors = <></>,
    } = props

    const onGridReady = (params: GridReadyEvent) => {
        setGridApi(params.api)
    }

    const selectorGridOptions: GridOptions = {
        rowSelection: rowSelectionType,
        onSelectionChanged,
        suppressRowClickSelection: true,
    }

    const generalGridOptions: GridOptions = {
        domLayout: 'autoHeight',
        pagination: true,
        paginationPageSize: STANDARD_PAGE_SIZE,
        sortingOrder: ['asc', 'desc'],
        tooltipShowDelay: 700,
    }

    const agGridTable = (
        <Box margin={{ top: 's' }}>
            <div className='ag-theme-quartz'>
                <AgGridReact
                    onGridReady={onGridReady}
                    columnDefs={colDefs}
                    autoSizeStrategy={autoSizeStrategy}
                    noRowsOverlayComponent={noRowsOverlayComponent}
                    gridOptions={
                        actionDropdownPermission
                            ? { ...selectorGridOptions, ...generalGridOptions }
                            : generalGridOptions
                    }
                />
            </div>
        </Box>
    )
    return includeTableHeader ? (
        <Container fitHeight>
            <Header
                actions={
                    <SpaceBetween size='xs' direction='horizontal'>
                        {additionalActions}
                        {primaryButtonPermission && primaryButton}
                        {actionDropdownPermission && actionDropdown}
                        {exportButton}
                    </SpaceBetween>
                }
            >
                <SpaceBetween size='s' direction='vertical'>
                    {tableHeaderName}
                    <SpaceBetween direction='horizontal' size='s'>
                        {additionalSelectors}
                        {selectors.map((selector, i) => (
                            <Select
                                key={i}
                                selectedOption={selector.selected}
                                onChange={selector.handler}
                                options={selector.options}
                                disabled={selector.loading}
                            />
                        ))}
                    </SpaceBetween>
                </SpaceBetween>
            </Header>
            {agGridTable}
        </Container>
    ) : (
        <>{agGridTable}</>
    )
}

export default GenericAGGridTable
